/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useState } from "react";
import Context from "../context/userContext";
import { post } from "../service/post";
import Auth from "../Utils/validateToken";

export default function useLogin() {
  const { cookies, setCookie, removeCookie } = useContext(Context);
  const [state, setstate] = useState({
    loading: false,
    error: false,
    message: "",
  });

  const login = useCallback(
    ({ email, password }) => {
      setstate({ loading: true, error: false, message: "" });
      post("auth/login", { email, password })
        .then((response) => {
          if (response.success) {
            setstate({ loading: false, error: false, message: "" });
            const token = Auth.encode(response);
            setCookie("jwt", token, { sameSite: true });
          } else {
            setstate({
              loading: false,
              error: true,
              message: response.message,
            });
            removeCookie("jwt");
          }
        })
        .catch((err) => {
          setstate({ loading: false, error: true, message: err });
          removeCookie("jwt");
        });
    },
    [removeCookie, setCookie]
  );

  const logout = useCallback(() => {
    removeCookie("jwt");
  }, [removeCookie]);

  return {
    isLoggedIn: Auth.decode(cookies.jwt),
    user: Auth.decode(cookies.jwt) ? Auth.decode(cookies.jwt).email : "",
    _id: Auth.decode(cookies.jwt) ? Auth.decode(cookies.jwt)._id : "",
    token: Auth.decode(cookies.jwt)
      ? "Bearer " + Auth.decode(cookies.jwt).access_token
      : undefined,
    role: Auth.decode(cookies.jwt) ? Auth.decode(cookies.jwt).role : "",
    municipio: Auth.decode(cookies.jwt) ? Auth.decode(cookies.jwt).municipio : "",
    loading: state.loading,
    error: state.error,
    message: state.message,
    login,
    logout,
  };
}
